export default async function GetCascadeChildPlansApi(planId) {
  let res = "";
  try {
    const token = "Bearer " + localStorage.getItem("authToken");
    const requestOptions = {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        accept: "application/json",
        Authorization: token,
      },
    };
    await fetch(
      `${process.env.REACT_APP_API_URL}v1/plans/${planId}/cascade-children`,
      requestOptions
    )
      .then((response) => response.json())
      .then((response) => {
        res = response;
      })
      .catch((error) => {
        console.error("Error: ", error);
        res = { success: false, message: "Failed to fetch cascade child plans" };
      });
  } catch (error) {
    console.error(error);
    res = { success: false, message: "Failed to fetch cascade child plans" };
  }

  return res;
}
